module.exports = __webpack_public_path__ + "img/nbus_footer_text_mo.b3c52c5d.png";